import { useEffect } from "react";
import PropTypes from "prop-types";
import NoItems from "../../../containers/customerItems/NoItems";
import ProductTiles from "../../../containers/customerItems/ProductTiles";
import ItemsHeader from "../../../containers/customerItems/ItemsHeader";
import ProductTile from "../../../containers/customerItems/ProductTile";
import SignInToSave from "../SignInToSave";
import LoadedItems from "../../common/LoadedItems";
import viewItemListEvent from "../../../../services/dataLayer/viewItemListEvent";

const CustomerItems = ({ itemCount, isAuthenticated, loadedSavedItems }) => {
  useEffect(() => {
    viewItemListEvent(loadedSavedItems);
  }, []);

  if (itemCount === 0) {
    return <NoItems />;
  }

  return (
    <>
      <LoadedItems
        ItemsHeader={ItemsHeader}
        ProductTiles={ProductTiles}
        ProductTile={ProductTile}
      />
      {!isAuthenticated && <SignInToSave />}
    </>
  );
};

CustomerItems.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
  itemCount: PropTypes.number.isRequired,
  loadedSavedItems: PropTypes.array.isRequired
};

export default CustomerItems;
